export const LANGUAGE = "LANGUAGE";
